import { CalciteLink } from '@esri/calcite-components-react';
import { CellRenderer } from './CellRenderer';
import { isValidUrl } from '../../../util/urlUtils';

export const TextCellRenderer: CellRenderer = ({ row, column }) => {
  const value = row[column.key];

  if (isValidUrl(value))
    return (
      <CellRenderer>
        <CalciteLink href={value} target="_blank" rel="noreferrer">
          {value}
        </CalciteLink>
      </CellRenderer>
    );

  return <CellRenderer>{value}</CellRenderer>;
};
